'use client'

import { CustomCmsSeller } from '../../../domain/seller'
import { SellerItemOpeningHours } from '../SellersMap/SellerItemOpeningHours'
import { useTranslation } from '../../context/ConfigContext'
import Accordion from '../Accordion/Accordion'

import StoreInformationsServices from './StoreInformationsServices'
import { HTMLStoreInformation } from './constants'

import useCurrentLocale from '../../../core/hook/useCurrentLocale'
import { getIsChinaStore, getIsKoreaLocale } from '../../utils/locale.utils'
import { useIsMobileOrTablet } from '../../utils/screen.utils'
import useStoreInformationBaiduMap from './useStoreInformationBaiduMap'
import useStoreInformationGoogleMap from './useStoreInformationGoogleMap'
import useStoreInformationNaverMap from './useStoreInformationNaverMap'
import Icon from '../Icon/Icon'
import { Icons } from '../Icon/constants'
import Image from '../Image/Image'

const useStoreInformationProviderUnused = (seller: CustomCmsSeller) => {
  const currentLocale = useCurrentLocale()

  if(getIsChinaStore(currentLocale)){
    return useStoreInformationBaiduMap(seller)
  }
  else if(getIsKoreaLocale(currentLocale)){
    return useStoreInformationNaverMap(seller)
  }

  return useStoreInformationGoogleMap(seller)
}

const StoreInformationPage = ({ seller }: { seller: CustomCmsSeller }) => {
  const t = useTranslation()
  const { defaultIniteraryLink } = useStoreInformationProviderUnused(seller)
  const isTablet = useIsMobileOrTablet()

  return (
    <div className='store-information-page'>
      <div className='store-information-page-container container'>
        <div className='left'>
          {/* <UnusedItineraryMap /> */}

          {isTablet && (
            <div className='store-informations-services-accordion'>
              <Accordion
                product={null}
                items={[
                  {
                    title: t('Additional Information', {}, false),
                    content: <StoreInformationsServices seller={seller} />,
                  },
                ]}
              />
            </div>
          )}
          {seller.image && (
          <Image src={seller.image} alt={seller.name}   className='img-responsive' />
          )}
          <div className='infos'>
            <h4 className='map-list-sellers-bytype-item-title'>{seller.name}</h4>
            <div className='address'>
              {seller.street} <br />
              {seller.postCode} {seller.city} <br />
              {seller.country}
              {seller.phone && (
                <a href={`tel:${seller.phone.replace(/ /g, '')}`} className='number'>
                  <Icon iconName={Icons.PHONE} />
                  <span>{seller.phone}</span>
                </a>
              )}
              <a
                className='button black see-itinerary-button'
                // onClick={(e) => {
                //   e?.preventDefault()
                //   seeItinerary(seller)
                // }}
                href={defaultIniteraryLink}
                target='_blank'>
                {t('Store-locator-itinerary', {}, true)}
              </a>
            </div>

            <SellerItemOpeningHours seller={seller} />
          </div>
        </div>

        <div className='right'>
          <div className='googleMap'>
            <div id={HTMLStoreInformation} className='store-information-map' />
          </div>
          {!isTablet && <StoreInformationsServices seller={seller} />}
        </div>
      </div>
    </div>
  )
}

export default StoreInformationPage
